module.exports = {
    "firstName": "John",
    "lastName": "Agent",
    "creditCards": [
        // {
        //     "zip": "76137",
        //     "country": "USA",
        //     "isExpiredCard": false,
        //     "city": "ftworth",
        //     "cardHolderName": "Test card",
        //     "isDefaultCard": true,
        //     // "cardType": "Visa",
        //     "cardType": "Discover",
        //     "cardToken": "kn7nczg",
        //     "cardBin": "411111",
        //     "streetAddress": "4901NBeach",
        //     "cardExpirationMonth": "12",
        //     "cardExpirationYear": "2020",
        //     "expiration": "12\/2020",
        //     "state": "TX",
        //     "cardNumber": "8888 xxxx 1111",
        //     "cardLast4": "1111"
        // },
        // {
        //   "zip": "76137",
        //   "country": "USA",
        //   "isExpiredCard": false,
        //   "city": "Fort Worth",
        //   "cardHolderName": "john",
        //   "isDefaultCard": false,
        //   "cardType": "Visa",
        //   "cardToken": "7zh27f",
        //   "cardBin": "411111",
        //   "streetAddress": "4901 N Beach St",
        //   "cardExpirationMonth": "12",
        //   "cardExpirationYear": "2022",
        //   "expiration": "12\/2022",
        //   "state": "null",
        //   "cardNumber": "411111 xxxx 1111",
        //   "cardLast4": "1111"
        // }
    ],
    "customerId": "023a3d625e",
    "company": "Century 21-Judge Fite Company",
    "email": "demo.agent@xpressdocs.com"
}